import GridOnIcon from '@mui/icons-material/GridOn';
import ListIcon from '@mui/icons-material/List';
import { IconButton, Tooltip } from '@mui/material';
import { memo } from 'react';
import { ViewMode as ViewModeType } from '../types';

export const ViewMode = memo(
  ({
    viewMode,
    onViewModeChange,
  }: {
    onViewModeChange: (viewMode: ViewModeType) => void;
    viewMode: ViewModeType;
  }) => {
    const isGridViewMode = viewMode === ViewModeType.GRID;

    return (
      <IconButton
        onClick={() => {
          onViewModeChange(
            isGridViewMode ? ViewModeType.LIST : ViewModeType.GRID,
          );
        }}
      >
        <Tooltip title={!isGridViewMode ? 'Mode grille' : 'Mode liste'}>
          {!isGridViewMode ? <GridOnIcon /> : <ListIcon />}
        </Tooltip>
      </IconButton>
    );
  },
);
